import { type Session, useSession } from "@sg-protect/shell";

function deriveIsMigrationProjectEnabled(products: Session["products"] | undefined): boolean {
    return products?.migrationProjects.isEnabled ?? false;
}

export function useIsMigrationProjectEnabled(): boolean {
    const { products } = useSession();

    return deriveIsMigrationProjectEnabled(products);
}
